import { render, staticRenderFns } from "./StartupError.vue?vue&type=template&id=3613e78a&"
import script from "./StartupError.vue?vue&type=script&lang=js&"
export * from "./StartupError.vue?vue&type=script&lang=js&"
import style0 from "./StartupError.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports